<template>
    <div class="flex column gap-40">
        <table class="subsidiary-list w-full">
            <!-- <thead style="position: sticky; top: 0; z-index: 10; background: #F6F6FC;">
                <tr>
                    
                    <th class='ordering' :class="sortingKey == 'location_type' ? 'sort-on' : ''" @click="sort('location_type')" >Label
                        <svg class='sort' :class="`orientation-${sorting['location_type']}`" xmlns="http://www.w3.org/2000/svg" width="320" height="512" viewBox="0 0 320 512"><path fill="currentColor" d="M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9S19 287.9 32 287.9h256c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"/></svg>
                    </th>
                    <th class='ordering' :class="sortingKey == 'location_type' ? 'sort-on' : ''" @click="sort('location_type')" >Status
                        <svg class='sort' :class="`orientation-${sorting['location_type']}`" xmlns="http://www.w3.org/2000/svg" width="320" height="512" viewBox="0 0 320 512"><path fill="currentColor" d="M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9S19 287.9 32 287.9h256c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"/></svg>
                    </th>
                    <th class='ordering' :class="sortingKey == 'company_type' ? 'sort-on' : ''" @click="sort('company_type')" >Due Diligence
                        <svg class='sort' :class="`orientation-${sorting['company_type']}`" xmlns="http://www.w3.org/2000/svg" width="320" height="512" viewBox="0 0 320 512"><path fill="currentColor" d="M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9S19 287.9 32 287.9h256c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"/></svg>
                    </th>
                    <th class='ordering' :class="sortingKey == 'createdAt' ? 'sort-on' : ''" @click="sort('createdAt')">Created At
                        <svg class='sort' :class="`orientation-${sorting['createdAt']}`" xmlns="http://www.w3.org/2000/svg" width="320" height="512" viewBox="0 0 320 512"><path fill="currentColor" d="M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9S19 287.9 32 287.9h256c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"/></svg>
                    </th>
                    
                </tr>
            </thead> -->
            <tbody class='table-content border-section'>
                <tr class="account-list">
                    <td class="user-info"> Company</td>
                    <td class="user-info"> {{  companyData.name.value }}</td>
                </tr>
                <!-- <tr class="account-list">
                    <td class="user-info"> Regime</td>
                    <td class="user-info"> KYC </td>
                </tr> -->
                <tr class="account-list">
                    <td class="user-info"> Period</td>
                    <td class="user-info"> 
                        {{ new Date(filters.date_from).toLocaleDateString() }} up till 
                        {{ new Date(filters.date_to).toLocaleDateString() }}
                    </td>
                </tr>
                <tr class="account-list">
                    <td class="user-info"> Status</td>
                    <td class="user-info flex row gap-5px">
                        <div class='item' v-for="item in filters.status">
                            {{ capitalizeFirstLetter(item) }}
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="report-section">
            <div class="flex column gap-40 align-center" >
                <ActionNeeded2
                    v-for="(report, index) in reportData.element"
                    :key="index"
                    :reviewAction="report"
                    :isReport="true"
                    :view="'change-log-item'"
                />
            </div>

        </div>
<br>
        <!-- {{ reportData }} -->

    </div>
</template>

<script setup>
    import { ref, computed } from 'vue';
    import { useRoute } from 'vue-router';
    import { useStore } from 'vuex';
    import ActionNeeded2 from '@/dialogs/ActionNeeded2.vue'

    const props = defineProps(['reportData', 'filters']);
    
    const store = useStore();

    const companyData = computed(() => store.state.companyData);

    function capitalizeFirstLetter(str) {
        if (!str) return '';
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

</script>

<style scoped lang="scss">




.subsidiary-list {
        padding: 20px;
        width: 100%;
        border-collapse: collapse;
        th, td {
            // border: 1px solid #ccc;
            padding: 15px;
            text-align: left;
            border: none;
            padding-left: 30px;
            color: black;
        }
        td {
            padding-top: 19px;
            padding-bottom: 19px;
        }
        th {
            text-align: left;
            border: none;
        }
        tr {
            border-top: 1px solid #ccc;
        }
        tbody {
            tr {
                cursor: pointer;
                td {
                    background: white;
                }

                &:last-child {
                    td {
                        &:first-child {
                            border-bottom-left-radius: 10px;
                        }
                        &:last-child {
                            border-bottom-right-radius: 10px;
                        }
                    }
                }
                &:hover {
                    td {
                        background: #f9f9f9;
                    }
                }
            }
        }
    }
</style>